import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useGateSuggestions = (options = { fallbackData: undefined }) => {
  const key = 'api/gate-rank-predictor-suggestions';
  const { data: gateSuggestionData, ...rest } = useFetch(
    key,
    { useCamelCase: true, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    gateSuggestionData,
    ...rest
  };
};

export default useGateSuggestions;
